
import { ManifestoABI } from "../../abis/Manifesto.abi";
import { Web3ContractProvider, Web3ProviderExtras } from "../web3.provider";

import {
  ManifestoContractEventType,
  ManifestoContractFunctions,
  // @ts-ignore
} from "./sw-contract-functions";

const Web3ManifestoProvider = async (
  addressOrName: string,
  extras?: Partial<Web3ProviderExtras<ManifestoContractEventType>>
) => {
  return Web3ContractProvider<ManifestoContractEventType, ManifestoContractFunctions>(
    addressOrName,
    ManifestoABI,
    extras as Web3ProviderExtras<ManifestoContractEventType>
  );
};

export { Web3ManifestoProvider, ManifestoContractEventType, ManifestoContractFunctions };
